export function enumValues(enumObject) {
  return Object.entries(enumObject).map((x) => x[1])
}
